// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  STRIPE_ID: 'sk_test_DYp7qYLQrdpNtkG8tvyGb1Ah',
  PUBLISHABLE_KEY: 'pk_test_A4omVIvpr37tDlsvqJ08GMXX',

  // PRD
  // STRIPE_ID: 'sk_live_XnkFH5XE331ynbDvK6HZyJlu',
  // PUBLISHABLE_KEY: 'pk_live_jI0PowY03Ek0RjNFrv3vrWxK',

  RESTAURANT_ID: 'name',

  LANGUAGE: {
    defaultLanguage: 'pt',
    supportedLanguages: {
      pt: './assets/icon/ptFlag.png',
      en: './assets/icon/ukFlag.png'
    }
  },

  firebaseConfig: {
    apiKey: 'AIzaSyDxiMAmLUqiYpWyDipDljWYRsYvKCho7Y0',
    authDomain: 'scuver-data.firebaseapp.com',
    databaseURL: 'https://scuver-data-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'scuver-data',
    storageBucket: 'scuver-data.appspot.com',
    messagingSenderId: '326732084118',
    appId: '1:326732084118:web:2ad29e73e90879d830e3b7'
  }

  // firebaseConfig: {
  //   apiKey: 'AIzaSyCrqVXgkYlLLGOOnoF_9Y5MD0pzjwCyJdU',
  //   authDomain: 'eatmatic-143319.firebaseapp.com',
  //   databaseURL: 'https://eatmatic-143319.firebaseio.com',
  //   projectId: 'eatmatic-143319',
  //   storageBucket: 'eatmatic-143319.appspot.com',
  //   messagingSenderId: '1088252386731'
  // }

  /*firebaseConfig: {
    apiKey: 'AIzaSyCrqVXgkYlLLGOOnoF_9Y5MD0pzjwCyJdU',
    authDomain: 'eatmatic-143319.firebaseapp.com',
    databaseURL: 'https://eatmatic-143319-8b6f2.firebaseio.com',
    projectId: 'eatmatic-143319',
    storageBucket: 'eatmatic-143319.appspot.com',
    messagingSenderId: '1088252386731'
  }*/
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';
